import MentorshipsApp from 'hb-react/frontoffice/apps/Mentorships/startup/MentorshipsApp';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';

// TODO: to be removed, when removing flag flag-ev-mentoring-multiple-mentor-programs

const MentorshipsAppWrapper = ({ topic }) => {
  const { topicId } = useTopicContext();

  return (
    <MentorshipsApp
      routes={{
        fetchMentors: Routes.topics_topic_mentors_path(topicId),
      }}
      topic={topic}
    />
  );
};

const TopicMentorshipsContainer = (props) => (
  <MentorshipsAppWrapper {...props} />
);

export default TopicMentorshipsContainer;
